export type SpaceTransferHandoff = {
  mode: "export" | "import";
  spaceId: string;
};

/** A navigation request, never authority or an automatic import/export.
 * Запит переходу, не дозвіл і не автоматичний запуск перенесення. */
export function readSpaceTransferHandoff(params: URLSearchParams): SpaceTransferHandoff | null {
  const mode = params.get("spaceTransfer");
  const spaceId = params.get("space");
  if (
    (mode !== "export" && mode !== "import") ||
    !spaceId ||
    !/^[A-Za-z0-9_-]{1,96}$/.test(spaceId) ||
    params.getAll("spaceTransfer").length !== 1 ||
    params.getAll("space").length !== 1
  )
    return null;
  return { mode, spaceId };
}

export function spaceTransferHandoffPath(handoff: SpaceTransferHandoff): string {
  return `/app?${new URLSearchParams({ spaceTransfer: handoff.mode, space: handoff.spaceId })}`;
}

export function safeSignInDestination(next: string | null): string {
  if (next === "/integrations/setup" || next === "/rooms" || next === "/room-invite") return next;
  if (next?.startsWith("/app?")) {
    const url = new URL(next, "https://handoff.invalid");
    if (
      url.pathname !== "/app" ||
      url.hash ||
      [...url.searchParams.keys()].some((key) => key !== "spaceTransfer" && key !== "space")
    )
      return "/app";
    const handoff = readSpaceTransferHandoff(url.searchParams);
    if (handoff) return spaceTransferHandoffPath(handoff);
  }
  return "/app";
}

export function spaceTransferSignInPath(pathname: string, search: string): string {
  const handoff =
    pathname === "/app" ? readSpaceTransferHandoff(new URLSearchParams(search)) : null;
  return handoff
    ? `/sign-in?${new URLSearchParams({ next: spaceTransferHandoffPath(handoff) })}`
    : "/sign-in";
}
